
namespace RioERP.Wallet {
    export class CreditJournalColumns {
        static columnsKey = 'Wallet.CreditJournal';
    }
}